import { effects } from 'redux-saga'
import callWithHmac from '../effects/callWithHmac'

import { receiveClients, receiveClientsSearch } from '../../modules/client'
import { begin, end } from '../../modules/loading'

export default function* searchSaga(invocation, action = { payload: {} }) {
  const query = action.payload.query

  try {
    yield effects.put.resolve(begin('clients', [query]))
    const result = yield effects.call(
      callWithHmac,
      invocation.searchClients,
      query,
    )

    yield effects.put.resolve(receiveClients(result.clients))
    yield effects.put.resolve(receiveClientsSearch(query, result.clients))
  } finally {
    yield effects.put.resolve(end('clients', [query]))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/client/search.js